/**
 * Canonical path segment for linking to an arche.
 *
 * Internal arches (IDs starting with `arche_`) use the archId so the
 * ArcheInteractionPage dispatch chain can match them by literal ID.
 * Plugin arches (IDs starting with `arc_`) use the slug for friendly URLs;
 * GenericArchePage resolves them via the metadata endpoint.
 *
 * This matches the slug-to-archId redirect rule in ConditionalProtectedRoute.
 */
export function archePath(arche: { archId: string; slug?: string | null }): string {
  if (arche.archId.startsWith('arche_')) {
    return arche.archId;
  }
  return arche.slug || arche.archId;
}
